import { render, staticRenderFns } from "./OrderFormFields.vue?vue&type=template&id=db87257e&scoped=true&"
import script from "./OrderFormFields.vue?vue&type=script&lang=js&"
export * from "./OrderFormFields.vue?vue&type=script&lang=js&"
import style0 from "./OrderFormFields.vue?vue&type=style&index=0&id=db87257e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db87257e",
  null
  
)

export default component.exports